import React from "react";
import { InfoSection, InfoSectionSecond } from "../../components";
import { homeObjOne, homeObjThree, homeObjTwo, homeObjFour } from "./Data";

const Home = () => {
  return (
    <>
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjFour} />
      <InfoSectionSecond {...homeObjTwo} />
    </>
  );
};

export default Home;
